import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

const Header = ({ siteTitle }) => (
  <header>
    <nav>
      <Link to="/poems">Poems</Link>
      <Link to="/stories">Stories</Link>
      <Link to="/posts">Missives</Link>
      <Link to="/other">Other</Link>
    </nav>
  </header>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
